import React, { Component, Fragment } from 'react';
import ModalT1 from "./Modal";
import { SingleDatePicker } from 'react-dates';
import Input from 'Components/Input/index';
import Select from 'react-select';
import { ReactComponent as UploadIcon } from 'Icons/upload.svg';
import { ReactComponent as PhotoLibrary } from 'Icons/photo-library.svg';
import { ReactComponent as Edit } from 'Icons/editIconT1.svg';
import {  ReactComponent as Calender } from 'Icons/calender.svg';
import { ReactComponent as Delete } from 'Icons/delete.svg';
import { isDesmetSupplier } from 'Utils/index';
import Upload from "Components/Upload/index";
import Moment from 'moment';
import RemarksConfirmationPopup from './remarksConfirmationPopup';

class ProductionStatus extends Component {
    constructor() {
        super();
        this.state={}
    }

    handleReject = (processData = '') => {
        this.setState(prevState => {
            return {
                isRejectPopup: !prevState.isRejectPopup,
                remarks: '',
                processData
            }
        })
    }

    onConfirm = () => {
        const { processData, remarks } = this.state;
        this.props.onClickApproveOrReject(2, 2, processData, this.props.partData, remarks);
        this.handleReject();
    }

    render() {
        const isSupplier =  isDesmetSupplier();
        const { data, partData, updateNextProcess, poDropdownLists, onSelectProcessStatus, isModalPopupOpen, handleModalPopupClose, onUploadDocument, onChangeProcessStatus, onChangeProcessInput, onSaveProductionStatus, onChangeProductionStatusDates, onClickEdit, editId, onUpdateProductionStatus, onClickApproveOrReject } = this.props;
        return (
            <Fragment>
                <ModalT1 
                    isOpenState={isModalPopupOpen}
                    handleOnClickForClose={handleModalPopupClose}>
                        <div className={'raw-modal pr-status pv-10 ph-10'}>
                            <div className={'fs-20 fSemibold'}>Production Status</div>
                            <div className="fs-16 fSemibold mt-20">
                               <span>Item Number : </span><span style={{'color': '#597EF7'}}>{partData.po_number}</span> 
                                <span style={{'color': '#858991'}}> <b className="ml-10 mr-10">|</b> Net Weight : {partData.net_weight}  Kg</span>
                            </div>
                            <div style={{'border': '1px solid #D3D9EC'}} className={'mt-20 br-5'}>
                                {isSupplier && <div className="pv-10 ph-10 flex flex-between flex-middle">
                                    <div className={'fs-18 fSemibold'}>Production Details</div>
                                    {!(data || []).find(el => el.production_status_id) && <div className="divButton" onClick={updateNextProcess}>+ Update Next Process</div>}
                                </div>}
                                <div className={'rmTable'}>
                                    <table width={'100%'} cellSpacing={0}>
                                        <tr>
                                            <th className={'wt-150'}>Process</th>
                                            <th>Start Date</th>
                                            <th>Completion Date</th>
                                            <th>Production Status</th>
                                            <th className={isSupplier ? 'wt-100' : ''}>Upload Document</th>
                                            {isSupplier && <th className={'wt-100'}>Approval Required</th>}
                                            <th>Remark</th>
                                            <th className={'wt-80'}>Actions</th>
                                        </tr>
                                        {isSupplier ?
                                        <>
                                            {(data || []).map((processData, pIndex) => {
                                                const isUnEditable = (processData.production_status_id && editId !=  processData.production_status_id)
                                            return(<tr>
                                                <td className={isUnEditable ? 'disabled' : ''}>
                                                    <Select 
                                                        placeholder={'Select Process'}
                                                        options={poDropdownLists.productionProcess || []}
                                                        getOptionLabel={(option) => option.value}
                                                        getOptionValue={(option) => option.id}
                                                        value={processData.process && (poDropdownLists.productionProcess || []).find(el => el.value === processData.process)}
                                                        onChange={(option) => onSelectProcessStatus(option, pIndex, 'process', 'process_id')}
                                                    />
                                                </td>
                                                <td className={isUnEditable ? 'disabled' : ''}>
                                                    <SingleDatePicker 
                                                        className="pInput" 
                                                        customInputIcon={[<Calender className='wt-15 ht-15'/>]} 
                                                        inputIconPosition={'after'}
                                                        displayFormat={"DD MMM YYYY"}
                                                        isOutsideRange={() => false}
                                                        hideKeyboardShortcutsPanel={true}
                                                        placeholder={"dd/mm/yyyy"}
                                                        numberOfMonths={2}
                                                        date={processData.start_date ? Moment(processData.start_date) : ''} 
                                                        onDateChange={(date) => onChangeProductionStatusDates(date, 'start_date', pIndex)}
                                                        focused={this.state[`focusedStartDate${pIndex}`]}
                                                        onFocusChange={({ focused }) => this.setState({ [`focusedStartDate${pIndex}`]: focused })}
                                                    />
                                                </td>
                                                <td className={isUnEditable ? 'disabled' : ''}>
                                                    <SingleDatePicker 
                                                        className="pInput" 
                                                        customInputIcon={[<Calender className='wt-15 ht-15'/>]} 
                                                        inputIconPosition={'after'}
                                                        displayFormat={"DD MMM YYYY"}
                                                        isOutsideRange={() => false}
                                                        hideKeyboardShortcutsPanel={true}
                                                        placeholder={"dd/mm/yyyy"}
                                                        numberOfMonths={2}
                                                        date={processData.completion_date ? Moment(processData.completion_date) : ''} 
                                                        onDateChange={(date) => onChangeProductionStatusDates(date, 'completion_date', pIndex)}
                                                        focused={this.state[`focusedCompletionDate${pIndex}`]}
                                                        onFocusChange={({ focused }) => this.setState({ [`focusedCompletionDate${pIndex}`]: focused })}
                                                    />
                                                </td>
                                                <td className={isUnEditable ? 'disabled' : ''}>
                                                    <Select 
                                                        placeholder={'Select Production Status'}
                                                        options={poDropdownLists.productionStatus || []}
                                                        getOptionLabel={(option) => option.value}
                                                        getOptionValue={(option) => option.id}
                                                        value={processData.production_status_name && (poDropdownLists.productionStatus || []).find(el => el.value === processData.production_status_name)}
                                                        onChange={(option) => onSelectProcessStatus(option, pIndex, 'production_status_name', 'production_status')}
                                                    />
                                                </td>
                                                <td>
                                                    <Upload onChange={(file) => onUploadDocument(file, pIndex, 2)} className={isUnEditable ? 'disabled' : ''}>
                                                        <UploadIcon className={isUnEditable ? 'disabled wt-25 ht-25' : 'wt-25 ht-25 curP'}/>
                                                    </Upload>
                                                    {processData.uploaded_doc && 
                                                        <div className={'uploaded-data fs-14'}>
                                                            <div
                                                                // href={(processData.uploaded_doc || {}).url}
                                                                // download
                                                                onClick={() => this.props.downloadUploadedFile((processData.uploaded_doc || {}).name)}
                                                            >
                                                                <PhotoLibrary className="mr-10 wt-15 ht-15 curP" />
                                                                {(processData.uploaded_doc || {}).name}
                                                            </div>
                                                        </div>}
                                                </td>
                                                <td className={isUnEditable ? 'disabled' : ''}>
                                                    <div className="switch" >
                                                        <input type="checkbox"  checked={processData.is_approval_required} id={pIndex} onChange={(e) => onChangeProcessStatus(e, pIndex)}/>
                                                        <label htmlFor={pIndex}></label>
                                                    </div>
                                                    {/* <div>{processData.approverMessage}</div> */}
                                                </td>
                                                <td className={isUnEditable ? 'disabled' : ''}>
                                                    <Input 
                                                        className={'fs-14'}
                                                        placeholder={'Enter Remarks'}
                                                        value={processData.remarks}
                                                        name={'remarks'}
                                                        onChange={(e) => onChangeProcessInput(e, pIndex)}
                                                    />
                                                </td>
                                                <td>
                                                    {(!processData.is_accept || [5].includes(this.props.activeStatusTab)) && <div className={'flex flex-middle'}>
                                                        {(processData.production_status_id) ? 
                                                            <>
                                                                <div className={'pv-5 pl-5 pr-5 border-theme-1 dark-blue br-5 fs-12 mr-10 fSemibold curP'} onClick={() => onUpdateProductionStatus(processData, partData)}>Update</div>
                                                                <Edit className={'wt-20 ht-20 curP'} fill={'#627fe9'} onClick={() => onClickEdit(processData.production_status_id)}/>
                                                            </>
                                                            : 
                                                            <>
                                                            <div className={'pv-5 pl-5 pr-5 border-theme-1 dark-blue br-5 fs-12 mr-10 fSemibold curP'} onClick={() => onSaveProductionStatus(processData, partData)}>Save</div>
                                                            {data.length > 0 && 
                                                                <Delete className={'wt-20 ht-20 curP'} onClick={() => this.props.onDeleteProductionStatus(pIndex)}/>
                                                            }
                                                            </>
                                                        }
                                                    </div>}
                                                    {
                                                            processData.approverMessage && <div className={processData.is_accept == 1 ? 'success-color fs-14 mt-5' : 'error-color fs-14 mt-5'}>{processData.approverMessage}</div>
                                                        }
                                                        {processData.rejected_remarks && 
                                                            <div className={'mt-5'}>{processData.rejected_remarks}</div>
                                                        }
                                                </td>
                                            </tr>)})}
                                        </> : 
                                        <>
                                            {(data || []).map((processData, pIndex) => {
                                            return(<tr>
                                                <td>{processData.process}</td>
                                                <td>{processData.start_date && Moment(processData.start_date).format('DD/MM/YYYY')}</td>
                                                <td>{processData.completion_date && Moment(processData.completion_date).format('DD/MM/YYYY')}</td>
                                                <td>{processData.production_status_name}</td>
                                                <td>
                                                    {(processData.uploaded_doc || {}).name &&<div className={'uploaded-data fs-14'}>
                                                        <a href={(processData.uploaded_doc || {}).url} download><PhotoLibrary className="mr-10 wt-15 ht-15" />{(processData.uploaded_doc || {}).name}</a>
                                                    </div>}
                                                </td>
                                                <td>
                                                    {processData.remarks}
                                                </td>
                                                <td>
                                                    {processData.is_approval_required && !processData.is_accept && <div className={'flex'}>
                                                        <div className={'pv-5 pl-5 pr-5 border-theme-1 dark-blue br-5 fs-12 mr-10 fSemibold wt-60'} onClick={() => onClickApproveOrReject(2, 1, processData, partData)}>Approve</div>
                                                        <div className={'pv-5 pl-5 pr-5 loi-cancelled-color border-red  br-5 fs-12 fSemibold wt-60'} onClick={() => this.handleReject(processData)}>Reject</div>
                                                    </div>}
                                                    {
                                                        processData.approverMessage && <div className={processData.is_accept == 1 ? 'success-color fs-14' : 'error-color fs-14'}>{processData.approverMessage}</div>
                                                    }
                                                </td>
                                            </tr>)})}
                                        </>}
                                    </table>
                                </div>
                            </div>
                            {/* {isSupplier && <div className={'mt-20 tCenter'}>
                                <button className={'divButton bgPrimary'} onClick={onSaveProductionStatus}>Save</button>
                            </div>} */}
                        </div>
                </ModalT1>
                {this.state.isRejectPopup && 
                <RemarksConfirmationPopup 
                    onChange={(e) => this.setState({ remarks: e.target.value })}
                    onCancel={this.handleReject}
                    onConfirm={this.onConfirm}
                    value={this.state.remarks}
                />}
            </Fragment>
        )
    }
}

export default ProductionStatus;
